var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damages-view view" }, [
    _vm.isE2EFlow
      ? _c(
          "div",
          { staticClass: "view_top" },
          [
            _c("ma-navbar-stepper", {
              attrs: {
                numberOfStep: 2,
                textOfStep: _vm.$t("Déclaration des dommages"),
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c("div", { staticClass: "view_content" }, [
      _c("div", { staticClass: "view_content_markdown" }, [
        _c("h1", { staticClass: "view-title" }, [
          _vm._v(
            _vm._s(
              _vm.isE2EFlow
                ? _vm.$t("addDamages.e2eTitle")
                : _vm.$t("addDamages.title")
            )
          ),
        ]),
        _c(
          "ul",
          { staticClass: "view-list has-two-cols" },
          [
            _c(
              "li",
              [
                _c("ma-button", {
                  staticClass: "buttonAddDamage",
                  attrs: {
                    "qa-add-damage-btn": "",
                    handleButtonClick: _vm.handleClickAddDamages,
                    iconName: "plus",
                    buttonTitle: _vm.$t("addDamages.buttonTitle"),
                    buttonClass: "buttonsList",
                    type: "button",
                  },
                }),
              ],
              1
            ),
            _vm._l(_vm.damagesList, function (damage) {
              return _c(
                "li",
                [
                  _c("maButton", {
                    attrs: {
                      type: "buttonImg",
                      imgSrc:
                        damage.images.length > 0
                          ? damage.images[0].imageContent
                          : null,
                      buttonTitle: _vm.getSubtitle(damage.selfcare_title),
                      buttonClass: "buttonsList damageButton",
                      buttonSubtitle: damage.selfcare_subtitle,
                      idButton: damage.damage_id,
                    },
                    on: {
                      "click:btnDelete": _vm.handleDeleteDamage,
                      "click:photo": _vm.handleClickDamageDetail,
                    },
                  }),
                ],
                1
              )
            }),
          ],
          2
        ),
      ]),
    ]),
    _vm.damagesList.length > 0
      ? _c(
          "div",
          { staticClass: "view_actions" },
          [
            _c("ma-confrim-damages-btn", {
              attrs: {
                handleButtonClick: _vm.handleConfirmDamages,
                title: _vm.$t("actions.confirmAndContinue"),
                btnType: "functionalBtn",
                shouldBeDisabled: _vm.isContinueBtnDisabled,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.damagesList.length === 0 && _vm.isE2EFlow
      ? _c(
          "div",
          { staticClass: "view_actions" },
          [
            _c("ma-confrim-damages-btn", {
              attrs: {
                handleButtonClick: _vm.hadleConfirmNoDamages,
                title: _vm.$t("actions.confirmWithNoDamages"),
                btnType: "functionalBtn",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }